// ** Custom Components
import { createIconComponent } from "./createIconComponent";

// #####################################################

/**
 * Trophy Icons Component
 */
export const TrophySolidIcon = createIconComponent("trophy", "solid");

export const TrophyRegularIcon = createIconComponent("trophy", "regular");

// #####################################################
